export enum PromiseStatus {
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected',
}

/**
 * A generic error handler that opens an error modal with a generic error message and sends the error log to the server.
 * @param error - The error object
 * @param message
 */
export const onAjaxError = (error: unknown, message?: string, logError = false): void => {
  window.PMW.openErrorModal({
    message: message ? message : window.i18next.t('pmwjs_error_message'),
    log: logError,
  });
  console.error(error);
  if (logError) {
    window.PMW.log(getErrorToLogOnServer(error) ?? message);
  }
};

export const hasAjaxRequestBeenMade = (ajaxRequest: string): boolean => {
  initFiredAjaxRequestStorage();

  if (typeof window.firedAjaxRequests[ajaxRequest] !== 'undefined' && window.firedAjaxRequests[ajaxRequest]) {
    return true;
  }

  return false;
};

export const recordAjaxRequest = (ajaxRequest: string): void => {
  initFiredAjaxRequestStorage();
  window.firedAjaxRequests[ajaxRequest] = true;
};

export const removeRecordedAjaxRequest = (ajaxRequest: string): void => {
  initFiredAjaxRequestStorage();
  window.firedAjaxRequests[ajaxRequest] = false;
};

const initFiredAjaxRequestStorage = (): void => {
  if (typeof window.firedAjaxRequests === 'undefined') {
    window.firedAjaxRequests = {};
  }
};

const getErrorToLogOnServer = (error: unknown): string | null => {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (error !== null && typeof error === 'object' && Object.prototype.hasOwnProperty.call(error, 'message')) {
    return (error as {message: string}).message;
  }

  return null;
};

export interface AjaxSuccessResponse {
  status: 'success' | 'fail' | 'error';
  data: any;
}

export interface AjaxResponse {
  error?: AjaxError;
  data?: any;
  code?: string;
  meta?: {
    requestId: string;
  };
}

export interface AjaxError {
  error: {
    name: string;
    message: string;
    stack: string;
  };
}
